import {observable, action, computed} from 'mobx'
import uniqid from 'uniqid'
import {notification} from 'antd'

export class Symbols {
  @observable list
  @observable symbols
  @observable indeces
  @observable searchList
  @observable loading = false

  constructor(rootStore) {
    this.rootStore = rootStore
    this.list = []
    this.symbols = []
    this.indeces = []
    this.searchList = []
  }

  @computed get searching() {
    return this.searchList.length > 0
  }

  @computed get type() {
    const type = this.rootStore.algo.single.data.has_coin ? 3 : 1
    return type
  }

  @computed get symbolsRegex() {
    if (this.symbols && this.symbols.length) {
      return new RegExp(`\\b${this.symbols.join('|')}\\b`, 'ig')
    } else {
      // this regex will match nothing
      return /.^/
    }
  }

  @action reset(type) {
    this[type] = []
  }

  @action search(searchStr, type = this.type) {
    if (!searchStr) {
      searchStr = 'a'
    }
    this.loading = true
    const id = uniqid()
    this.searchList.push(id)
    this.list = []
    return this.rootStore.api.request(`data/symbols?symbol_type=${type}&search=${searchStr}`, 'get')
      .then(resObj => {
        this.list = resObj.results
      }).catch((e) => {
        notification['error']({
          message: 'Failed to get tickers',
          description: e.message || 'Unknown error'
        })
      }).finally(() => {
        this.searchList = this.searchList.filter(searchId => searchId !== id)
        this.loading = false
      })
  }

  @action validate(id) {
    return this.rootStore.api.request(`data/symbols/${id}`)
      .then(resObj => {
        if (typeof resObj.id === 'number') {
          return true
        } else {
          return false
        }
      }).catch((e) => {
        notification['error']({
          message: 'Failed to validate ticker',
          description: e.message || 'Unknown error'
        })
        return false
      })
  }

  @action isSymbol = (text) => {
    if (['day', 'today', 'and', 'open', 'ago', 'i'].indexOf(text.toLowerCase()) !== -1) {
      return new Promise((resolve, reject) => { //eslint-disable-line
        resolve(false)
      })
    }
    if (this.symbols.includes(text.toUpperCase())) {
      return new Promise((resolve, reject) => { //eslint-disable-line
        resolve(true)
      })
    }
    const fetchIndeces = this.indeces.length ? this.fetchIndeces(text) : false
    const fetchSymbols = this.rootStore.api.request(`data/symbols?symbol_type=${this.type}&search=${text}`, 'get')
      .then(resObj => {
        if (resObj.results.find(row => row.symbol === text.toUpperCase())) {
          this.symbols.push(text.toUpperCase())
          return true
        }
        return false
      })

    return Promise.all([fetchIndeces, fetchSymbols])
      .then(results => results.some(result => result))
  }

  @action fetchIndeces(text) {
    return this.rootStore.api.request('data/symbols?symbol_type=2', 'get')
      .then(resObj => {
        this.indeces = resObj.results.map(index => index.toUpperCase())
        if (resObj.results.find(row => row.symbol === text.toUpperCase())) {
          return true
        }
      })
  }
}
